// extracted by mini-css-extract-plugin
module.exports = {"adminBadge":"Navbar_adminBadge_3NsIK"};